import { companiesTypes } from '../actions/_companies_actions';

const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case companiesTypes.GETTING_COMPANIES:
      return [...action.companies];
    case companiesTypes.MANAGE_COMPANY:
      return [...action.companies];
    default:
      return state;
  }
};
